import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_hmd_font = _resolveComponent("hmd-font")!

  return (_openBlock(), _createElementBlock("span", null, [
    (_ctx.value === true)
      ? (_openBlock(), _createBlock(_component_hmd_font, {
          key: 0,
          type: _ctx.trueType
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.trueText), 1)
          ]),
          _: 1
        }, 8, ["type"]))
      : _createCommentVNode("", true),
    (_ctx.value === false)
      ? (_openBlock(), _createBlock(_component_hmd_font, {
          key: 1,
          type: _ctx.falseType
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.falseText), 1)
          ]),
          _: 1
        }, 8, ["type"]))
      : _createCommentVNode("", true)
  ]))
}